import { formatMoney } from '@core/money/format';
import { asMoney } from '@core/money/types';
import { useInvoicePaymentHistory } from './useInvoicePayments';

const money = (paise: number) => formatMoney(asMoney(paise));

export function InvoicePaymentHistory({ documentId }: { readonly documentId: string }) {
  const history = useInvoicePaymentHistory(documentId);
  if (history.isLoading) return <p className="text-xs text-slate-500">Loading payment history…</p>;
  if (history.isError) return <p role="alert" className="text-xs text-red-300">Payment history could not be loaded.</p>;
  if (!history.data?.length) return <p className="text-xs text-slate-500">No payments recorded against this invoice.</p>;

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-left text-xs">
        <thead className="border-b border-slate-800 text-slate-500">
          <tr><th className="py-1.5 pr-2">Date / receipt</th><th className="py-1.5 pr-2">Method / reference</th><th className="py-1.5 pr-2 text-right">Amount applied</th><th className="py-1.5 text-right">Record</th></tr>
        </thead>
        <tbody>
          {history.data.map(({ payment, allocation }) => (
            <tr key={allocation.id} className="border-b border-slate-800/50 last:border-0">
              <td className="py-2 pr-2">{payment?.paymentDate ?? allocation.createdAt.slice(0, 10)}<div className="text-slate-500">{payment?.paymentNumber ?? 'Reversed allocation'}</div></td>
              <td className="py-2 pr-2">{payment ? payment.method : 'Payment reversed'}{payment?.reference ? <div className="text-slate-500">{payment.reference}</div> : null}</td>
              <td className="py-2 pr-2 text-right">{money(allocation.amountPaise)}</td>
              <td className="py-2 text-right">{allocation.voidedAt ? <span className="text-amber-400">Reversed</span> : <span className="text-emerald-400">Applied</span>}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
